import Settings from './Settings.jsx';

export default Settings;
